var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacypolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 409.641,
    height: 306.832,
    viewBox: "0 0 409.641 306.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "translate(-127.679 -72.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2540",
    "data-name": "Group 2540",
    transform: "translate(299.98 72.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2515",
    "data-name": "Group 2515",
    transform: "translate(0 131.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8514",
    "data-name": "Path 8514",
    d: "M520.828,239l0,.011-38.537-6.589L433.347,246.9l-20.9-7.713c-2.911.721-5.517,1.445-7.874,2.175h0s-75.485,12.061-66.394,78.864l42.185,1.01c1.171,3.623,1.255,2.747,2.1,4.912l15.108,49.943H521.208l1.149-40.747,37.52,24.147a7.346,7.346,0,0,0,11.293-5.5c1.589-17.341,3.505-47.858,3.533-48.65C576.68,249.83,520.828,239,520.828,239Z",
    transform: "translate(-337.415 -232.417)",
    fill: "#7cb4f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8515",
    "data-name": "Path 8515",
    d: "M392.778,348.522a.823.823,0,0,1-.8-.617l-7.516-29.285a.822.822,0,1,1,1.591-.409l7.517,29.285a.824.824,0,0,1-.592,1A.844.844,0,0,1,392.778,348.522Z",
    transform: "translate(-345.808 -247.62)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8516",
    "data-name": "Path 8516",
    d: "M563.5,350.744a.817.817,0,0,1-.5-.17L539.95,332.842a11.38,11.38,0,0,1-5.026-8.357l-2.375-23.275a.821.821,0,0,1,.734-.9.83.83,0,0,1,.9.734l2.376,23.275a9.778,9.778,0,0,0,4.345,7.187L564,349.271a.821.821,0,0,1-.5,1.473Z",
    transform: "translate(-372.243 -244.534)",
    fill: "#121936"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2538",
    "data-name": "Group 2538",
    transform: "translate(47.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2537",
    "data-name": "Group 2537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2522",
    "data-name": "Group 2522",
    transform: "translate(6.301 31.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2521",
    "data-name": "Group 2521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2520",
    "data-name": "Group 2520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2519",
    "data-name": "Group 2519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2518",
    "data-name": "Group 2518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2517",
    "data-name": "Group 2517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2516",
    "data-name": "Group 2516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8517",
    "data-name": "Path 8517",
    d: "M477.35,139.612h0l-11.39-.4a13.648,13.648,0,0,0-12.766,7.8l2.206-32.336s-11.4,6.6-26.353-2.041c0,0-17.2-5.706-22.589,7.6-.013.132-.031.264-.04.4l-3.311,48.07c-1.212,17.585,10.8,32.923,27.31,35.678l3.846,19.088a26.414,26.414,0,0,0,31.181,20.367l.593-.119c14.312-2.884,26.542-13.7,23.7-27.786L478.488,169.2l2.638.092a14.886,14.886,0,0,0,15.348-14.317l.039-1.089a13.675,13.675,0,0,0-13.12-14.066Z",
    transform: "translate(-403.023 -111.418)",
    fill: "#ffaa89"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8518",
    "data-name": "Path 8518",
    d: "M436.667,221.063s28.871-3.434,31.969-14.43h0s3.9,15.341-29.288,29.212Z",
    transform: "translate(-409.028 -127.54)",
    fill: "#ff6a48"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8519",
    "data-name": "Path 8519",
    d: "M503.085,163.08",
    transform: "translate(-420.882 -120.639)",
    fill: "none",
    stroke: "#121936",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2523",
    "data-name": "Group 2523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8520",
    "data-name": "Path 8520",
    d: "M495.368,191.032a24.011,24.011,0,0,1,2.183-9.108l-12.536-.435Z",
    transform: "translate(-411.356 -91.985)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8521",
    "data-name": "Path 8521",
    d: "M476.823,98.892s7.812-13.626-13.081-23.465-28.585,8.623-28.585,8.623-2.493-16.91-27.778-8.72-2.849,39.53-2.849,39.53c.168-.552.357-1.069.559-1.567,5.388-13.3,22.589-7.6,22.589-7.6,14.957,8.642,26.353,2.041,26.353,2.041l-1.958,28.712c-.849,5.74-1.978,13.336-2.787,18.768a5.476,5.476,0,0,1-7.468,4.27l-18.1-7.289a5.47,5.47,0,0,0-2.724-.356l-14.3,1.775a5.482,5.482,0,0,0-4.789,5.011l-1.075,13.706a25.735,25.735,0,0,0,26.231,27.743l7.979-.178a5.456,5.456,0,0,0,1.6-.275l2-.115a29.321,29.321,0,0,0,25.081-41.246h0a5.48,5.48,0,0,1-1.019-3.4l.831-20.945a5.36,5.36,0,0,0-.185-1.627c.408-.023.819-.034,1.235-.02l11.39.4,6.042.209a13.522,13.522,0,0,1,8.823,3.705c3.618-9.082,6.778-18.04,7.7-23.6C501.039,97.93,476.823,98.892,476.823,98.892Z",
    transform: "translate(-395.352 -72.539)",
    fill: "#121936"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8522",
    "data-name": "Path 8522",
    d: "M506.73,164.339",
    transform: "translate(-415.232 -88.924)",
    fill: "none",
    stroke: "#ff6969",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2536",
    "data-name": "Group 2536",
    transform: "translate(1.903 43.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8523",
    "data-name": "Path 8523",
    d: "M501.2,167.6a.815.815,0,0,1-.448-.133l-4.765-3.106a.823.823,0,0,1-.163-1.238l5.093-5.666a.822.822,0,1,1,1.223,1.1L497.69,163.5l3.961,2.582a.821.821,0,0,1-.449,1.51Z",
    transform: "translate(-415.151 -130.928)",
    fill: "#ff6a48"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2525",
    "data-name": "Group 2525",
    transform: "translate(9.093 19.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8524",
    "data-name": "Path 8524",
    d: "M409.543,151.215a3.094,3.094,0,1,0,3.672-2.382A3.094,3.094,0,0,0,409.543,151.215Z",
    transform: "translate(-408.869 -148.764)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8525",
    "data-name": "Path 8525",
    d: "M436.6,151.889a3.095,3.095,0,1,0,3.065-3.124A3.094,3.094,0,0,0,436.6,151.889Z",
    transform: "translate(-413.711 -148.764)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2524",
    "data-name": "Group 2524",
    transform: "translate(22.68 4.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8526",
    "data-name": "Path 8526",
    d: "M442.8,156.522a4.409,4.409,0,0,0-5.458.023",
    transform: "translate(-436.523 -154.75)",
    fill: "#ffa386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8527",
    "data-name": "Path 8527",
    d: "M437.167,157.189a.822.822,0,0,1-.5-1.471,5.2,5.2,0,0,1,6.483-.007.822.822,0,0,1-1.042,1.271,3.583,3.583,0,0,0-4.436.037A.815.815,0,0,1,437.167,157.189Z",
    transform: "translate(-436.345 -154.573)",
    fill: "#ff6a48"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8528",
    "data-name": "Path 8528",
    d: "M409.559,158.025A.821.821,0,0,1,409,156.6a4.729,4.729,0,0,1,6.179-.4.822.822,0,0,1-1.006,1.3,3.079,3.079,0,0,0-4.057.311A.821.821,0,0,1,409.559,158.025Z",
    transform: "translate(-408.737 -149.919)",
    fill: "#ff6a48"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8529",
    "data-name": "Path 8529",
    d: "M408.05,159.422c-5.724,0-10.381-5.332-10.381-11.887s4.656-11.886,10.381-11.886,10.38,5.332,10.38,11.886S413.773,159.422,408.05,159.422Zm0-22.131c-4.818,0-8.738,4.595-8.738,10.243s3.919,10.244,8.738,10.244,8.737-4.6,8.737-10.244S412.867,137.291,408.05,137.291Z",
    transform: "translate(-397.669 -127.085)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2526",
    "data-name": "Group 2526",
    transform: "translate(13.64 14.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8530",
    "data-name": "Path 8530",
    d: "M423.457,143.891v10.75H417.87a2.6,2.6,0,0,0-2.6,2.6v1.176a5.089,5.089,0,0,0,5.089,5.089h5.089",
    transform: "translate(-414.451 -143.07)",
    fill: "#ffaa89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8531",
    "data-name": "Path 8531",
    d: "M425.272,164.147h-5.089a5.917,5.917,0,0,1-5.911-5.911v-1.176a3.423,3.423,0,0,1,3.42-3.42h4.765v-9.927a.822.822,0,1,1,1.643,0v11.57h-6.408a1.779,1.779,0,0,0-1.777,1.777v1.176a4.273,4.273,0,0,0,4.268,4.268h5.089a.822.822,0,1,1,0,1.643Z",
    transform: "translate(-414.272 -142.892)",
    fill: "#ff6a48"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8532",
    "data-name": "Path 8532",
    d: "M438.537,158.511c-5.724,0-10.381-5.332-10.381-11.887s4.656-11.887,10.381-11.887,10.381,5.332,10.381,11.887S444.261,158.511,438.537,158.511Zm0-22.132c-4.817,0-8.738,4.6-8.738,10.244s3.92,10.244,8.738,10.244,8.738-4.6,8.738-10.244S443.355,136.379,438.537,136.379Z",
    transform: "translate(-403.11 -126.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2535",
    "data-name": "Group 2535",
    transform: "translate(5.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2534",
    "data-name": "Group 2534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2533",
    "data-name": "Group 2533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2529",
    "data-name": "Group 2529",
    transform: "translate(25.142 1.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2528",
    "data-name": "Group 2528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2527",
    "data-name": "Group 2527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8533",
    "data-name": "Path 8533",
    d: "M448.025,134.113a7.925,7.925,0,0,1-3.241-.6c-1.116-.362-2.245-.7-3.238-.956s-2.144-.517-3.3-.744a7.88,7.88,0,0,1-3.114-1.058c-.758-.582-.836-1.705.5-2.713,1.27-.99,4.1-1.688,7.389-.84s5.37,2.842,5.96,4.315C449.628,133.043,448.982,133.977,448.025,134.113Z",
    transform: "translate(-434.594 -126.824)",
    fill: "#121936"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2532",
    "data-name": "Group 2532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2531",
    "data-name": "Group 2531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2530",
    "data-name": "Group 2530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8534",
    "data-name": "Path 8534",
    d: "M404.759,130.488a5.469,5.469,0,0,0,2.58.01c.909-.135,1.825-.244,2.625-.306s1.724-.1,2.642-.111a5.438,5.438,0,0,0,2.543-.417c.662-.386.871-1.358-.03-2.462a6.668,6.668,0,0,0-5.591-1.953,6.546,6.546,0,0,0-5.17,2.805C403.663,129.286,404.038,130.212,404.759,130.488Z",
    transform: "translate(-403.989 -125.225)",
    fill: "#121936"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8535",
    "data-name": "Path 8535",
    d: "M428.058,148.638h-4.233a.822.822,0,1,1,0-1.643h4.233a.822.822,0,1,1,0,1.643Z",
    transform: "translate(-402.191 -129.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8536",
    "data-name": "Path 8536",
    d: "M452.25,147.626a.821.821,0,0,1-.076-1.639l25.152-2.374a.821.821,0,0,1,.154,1.636l-25.152,2.374C452.3,147.626,452.275,147.626,452.25,147.626Z",
    transform: "translate(-407.264 -128.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8537",
    "data-name": "Path 8537",
    d: "M433.423,185.089h-.1l-9.862-.126a.822.822,0,0,1,.01-1.643h.011l9.862.126a5.978,5.978,0,0,0,5.852-4.58l1.6.375A7.623,7.623,0,0,1,433.423,185.089Z",
    transform: "translate(-402.128 -134.799)",
    fill: "#ff6a48"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2539",
    "data-name": "Group 2539",
    transform: "translate(69.05 121.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8538",
    "data-name": "Path 8538",
    d: "M434.1,229.3l-12.637,10.932,1.886,25.835A1.594,1.594,0,0,0,426,267.14l23.244-20.711Z",
    transform: "translate(-421.467 -222.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8539",
    "data-name": "Path 8539",
    d: "M495.347,220.969l-41.333,23.849,16.6,27.869a2.431,2.431,0,0,0,3.66.612l40.208-34.047Z",
    transform: "translate(-427.276 -220.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8540",
    "data-name": "Path 8540",
    d: "M430.826,268.175l10.934,22.237L465.45,276.3l-15.165-25.467Z",
    transform: "translate(-423.137 -226.3)",
    fill: "#121936"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2555",
    "data-name": "Group 2555",
    transform: "translate(127.679 86.652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2553",
    "data-name": "Group 2553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8541",
    "data-name": "Path 8541",
    d: "M249.775,125.45l-25.578.179-33.4,0,.077-12.383a26.2,26.2,0,0,0-.422-4.869c-4.458-24.479-40.3-24.623-45.014-.192a26.247,26.247,0,0,0-.475,4.98v14.892h.015l.062,11.1c.064,11.734-7.509,21.766-17.336,23.946a15.7,15.7,0,0,0,2.366.113c1.8.048,3.239,0,3.239,0l95.4.124c11.748-.082,21.213-10.911,21.14-24.188Z",
    transform: "translate(-127.679 -89.757)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2552",
    "data-name": "Group 2552",
    transform: "translate(40.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2542",
    "data-name": "Group 2542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8542",
    "data-name": "Path 8542",
    d: "M336.082,125.235a35.381,35.381,0,0,0-23.057-33.164,26,26,0,0,0-10.671-2.353l-79.3.091.006-.011H179.828c-.578,0-1.149.025-1.718.062l-1.473,0v.048c.11.013.219.033.328.048a26.117,26.117,0,0,1,22.6,24.328h-.014V360.769a21.786,21.786,0,0,0,21.9,21.668H336.037V282.989h.044Z",
    transform: "translate(-176.637 -89.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2541",
    "data-name": "Group 2541",
    transform: "translate(45.735 118.204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8543",
    "data-name": "Path 8543",
    d: "M326.176,251.246H233.129a.821.821,0,1,1,0-1.642h93.046a.821.821,0,1,1,0,1.642Z",
    transform: "translate(-232.308 -236.46)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8544",
    "data-name": "Path 8544",
    d: "M303.739,235.247h-39.2a.822.822,0,0,1,0-1.643h39.2a.822.822,0,1,1,0,1.643Z",
    transform: "translate(-237.915 -233.604)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8545",
    "data-name": "Path 8545",
    d: "M326.176,274.732H233.129a.822.822,0,1,1,0-1.643h93.046a.822.822,0,0,1,0,1.643Z",
    transform: "translate(-232.308 -240.651)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8546",
    "data-name": "Path 8546",
    d: "M326.176,298.217H233.129a.822.822,0,0,1,0-1.643h93.046a.822.822,0,0,1,0,1.643Z",
    transform: "translate(-232.308 -244.843)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8547",
    "data-name": "Path 8547",
    d: "M326.176,320.2H233.129a.822.822,0,0,1,0-1.643h93.046a.822.822,0,1,1,0,1.643Z",
    transform: "translate(-232.308 -248.766)",
    fill: "#121936"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2551",
    "data-name": "Group 2551",
    transform: "translate(34.869 27.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2550",
    "data-name": "Group 2550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8548",
    "data-name": "Path 8548",
    d: "M276.393,125.2h0a3.185,3.185,0,0,0-6.217.985h0a3.185,3.185,0,0,1-5.769,1.874h0a3.185,3.185,0,0,0-5.609,2.858h0a3.185,3.185,0,0,1-4.908,3.565h0a3.185,3.185,0,0,0-4.451,4.451h0a3.185,3.185,0,0,1-3.565,4.907h0a3.185,3.185,0,0,0-2.858,5.609h0a3.185,3.185,0,0,1-1.874,5.769h0a3.185,3.185,0,0,0-.985,6.217h0a3.185,3.185,0,0,1,0,6.066h0a3.185,3.185,0,0,0,.985,6.217h0a3.185,3.185,0,0,1,1.874,5.769h0a3.185,3.185,0,0,0,2.858,5.608h0A3.185,3.185,0,0,1,249.44,190h0a3.185,3.185,0,0,0,4.451,4.451h0a3.185,3.185,0,0,1,4.908,3.565h0a3.185,3.185,0,0,0,5.609,2.858h0a3.185,3.185,0,0,1,5.769,1.874h0a3.185,3.185,0,0,0,6.217.985h0a3.185,3.185,0,0,1,6.066,0h0a3.185,3.185,0,0,0,6.217-.985h0a3.185,3.185,0,0,1,5.769-1.874h0a3.185,3.185,0,0,0,5.609-2.858h0a3.185,3.185,0,0,1,4.907-3.565h0A3.185,3.185,0,0,0,309.412,190h0a3.185,3.185,0,0,1,3.565-4.907h0a3.185,3.185,0,0,0,2.858-5.608h0a3.185,3.185,0,0,1,1.874-5.769h0a3.185,3.185,0,0,0,.985-6.217h0a3.185,3.185,0,0,1,0-6.066h0a3.185,3.185,0,0,0-.985-6.217h0a3.185,3.185,0,0,1-1.874-5.769h0a3.185,3.185,0,0,0-2.858-5.609h0a3.185,3.185,0,0,1-3.565-4.907h0a3.185,3.185,0,0,0-4.451-4.451h0a3.185,3.185,0,0,1-4.907-3.565h0a3.185,3.185,0,0,0-5.609-2.858h0a3.185,3.185,0,0,1-5.769-1.874h0a3.185,3.185,0,0,0-6.217-.985h0A3.185,3.185,0,0,1,276.393,125.2Z",
    transform: "translate(-222.448 -122.983)",
    fill: "#ffd066"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2548",
    "data-name": "Group 2548",
    transform: "translate(36.117 14.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8549",
    "data-name": "Path 8549",
    d: "M298.551,196.212H269.262a6.224,6.224,0,0,1-6.217-6.217V166.84a6.224,6.224,0,0,1,6.217-6.217h29.289a6.224,6.224,0,0,1,6.217,6.217v23.154A6.224,6.224,0,0,1,298.551,196.212Zm-29.289-33.124a3.757,3.757,0,0,0-3.753,3.753v23.154a3.757,3.757,0,0,0,3.753,3.753h29.289a3.757,3.757,0,0,0,3.753-3.753V166.84a3.757,3.757,0,0,0-3.753-3.753Z",
    transform: "translate(-263.045 -144.514)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8550",
    "data-name": "Path 8550",
    d: "M299.065,159.588a1.232,1.232,0,0,1-1.232-1.232v-6.728c0-4.494-4.145-8.149-9.238-8.149h-6.9c-5.093,0-9.238,3.655-9.238,8.149v6.728a1.232,1.232,0,0,1-2.465,0v-6.728c0-5.852,5.25-10.613,11.7-10.613h6.9c6.452,0,11.7,4.761,11.7,10.613v6.728A1.232,1.232,0,0,1,299.065,159.588Z",
    transform: "translate(-264.286 -141.014)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2547",
    "data-name": "Group 2547",
    transform: "translate(13.881 23.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2546",
    "data-name": "Group 2546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8551",
    "data-name": "Path 8551",
    d: "M294.357,176.371a7.223,7.223,0,0,0-14.41-.265,6.719,6.719,0,0,0,2.748,5.655,1.458,1.458,0,0,1,.6,1.16v1.88a1.5,1.5,0,0,0,1.534,1.46h4.632A1.5,1.5,0,0,0,291,184.8v-1.879a1.453,1.453,0,0,1,.6-1.159A6.729,6.729,0,0,0,294.357,176.371Z",
    transform: "translate(-279.942 -169.512)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2543",
    "data-name": "Group 2543",
    transform: "translate(5.476 17.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8552",
    "data-name": "Path 8552",
    d: "M289.91,192.715a1.526,1.526,0,1,1-1.526-1.526A1.527,1.527,0,0,1,289.91,192.715Z",
    transform: "translate(-286.652 -190.984)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8553",
    "data-name": "Path 8553",
    d: "M288.339,194.4a1.732,1.732,0,1,1,1.732-1.732A1.734,1.734,0,0,1,288.339,194.4Zm0-3.053a1.321,1.321,0,1,0,1.321,1.321A1.322,1.322,0,0,0,288.339,191.35Z",
    transform: "translate(-286.607 -190.939)",
    fill: "#ffd066"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2544",
    "data-name": "Group 2544",
    transform: "translate(4.174 16.941)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3422",
    "data-name": "Rectangle 3422",
    width: 5.655,
    height: 1.271,
    rx: 0.636,
    transform: "translate(0.205 0.205)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8554",
    "data-name": "Path 8554",
    d: "M290.328,191.816h-4.545a.762.762,0,0,1-.761-.761v-.16a.762.762,0,0,1,.761-.761h4.545a.761.761,0,0,1,.761.761v.16A.762.762,0,0,1,290.328,191.816Zm-4.545-1.271a.351.351,0,0,0-.35.35v.16a.351.351,0,0,0,.35.35h4.545a.35.35,0,0,0,.35-.35v-.16a.35.35,0,0,0-.35-.35Z",
    transform: "translate(-285.023 -190.134)",
    fill: "#ffd066"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2545",
    "data-name": "Group 2545",
    transform: "translate(4.52 18.212)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3423",
    "data-name": "Rectangle 3423",
    width: 4.963,
    height: 1.111,
    rx: 0.555,
    transform: "translate(0.206 0.205)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8555",
    "data-name": "Path 8555",
    d: "M290.127,193.2h-3.993a.691.691,0,0,1-.691-.691v-.14a.691.691,0,0,1,.691-.69h3.993a.691.691,0,0,1,.69.69v.14A.691.691,0,0,1,290.127,193.2Zm-3.993-1.111a.28.28,0,0,0-.28.279v.14a.281.281,0,0,0,.28.28h3.993a.28.28,0,0,0,.279-.28v-.14a.28.28,0,0,0-.279-.279Z",
    transform: "translate(-285.444 -191.681)",
    fill: "#ffd066"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8556",
    "data-name": "Path 8556",
    d: "M282.528,178.693a.308.308,0,0,1-.3-.226,4.854,4.854,0,0,1,1.73-5.157.308.308,0,0,1,.352.506,4.159,4.159,0,0,0-1.489,4.487.307.307,0,0,1-.3.389Z",
    transform: "translate(-280.317 -170.18)",
    fill: "#ffd066"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8557",
    "data-name": "Path 8557",
    d: "M238.88,136.457a.822.822,0,0,1-.511-.178l-7.752-6.174a.822.822,0,1,1,1.024-1.286l7.752,6.174a.821.821,0,0,1-.513,1.464Z",
    transform: "translate(-221.085 -123.993)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8558",
    "data-name": "Path 8558",
    d: "M219.9,173.083a.822.822,0,0,1-.187-1.622l9.649-2.263a.821.821,0,0,1,.375,1.6l-9.649,2.264A.821.821,0,0,1,219.9,173.083Z",
    transform: "translate(-219.081 -131.227)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8559",
    "data-name": "Path 8559",
    d: "M231.227,153.995a.848.848,0,0,1-.219-.03l-9.552-2.64a.822.822,0,0,1,.438-1.584l9.552,2.64a.822.822,0,0,1-.219,1.613Z",
    transform: "translate(-219.398 -127.754)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8560",
    "data-name": "Path 8560",
    d: "M343.577,172.511a.822.822,0,0,1-.066-1.641l9.877-.8a.821.821,0,1,1,.133,1.637l-9.877.8A.611.611,0,0,1,343.577,172.511Z",
    transform: "translate(-241.155 -131.387)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8561",
    "data-name": "Path 8561",
    d: "M342.062,153.995a.822.822,0,0,1-.218-1.613l9.552-2.64a.822.822,0,0,1,.438,1.584l-9.552,2.64A.846.846,0,0,1,342.062,153.995Z",
    transform: "translate(-240.885 -127.754)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8562",
    "data-name": "Path 8562",
    d: "M349.317,191.628a.815.815,0,0,1-.378-.093l-8.794-4.569a.821.821,0,1,1,.757-1.457l8.794,4.569a.821.821,0,0,1-.38,1.55Z",
    transform: "translate(-240.611 -134.126)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2549",
    "data-name": "Group 2549",
    transform: "translate(74.143 1.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8563",
    "data-name": "Path 8563",
    d: "M332.464,136.181a11.635,11.635,0,0,1-11.616,11.651,11.616,11.616,0,1,1,11.616-11.651Zm-20.724.073a9.087,9.087,0,0,0,9.1,9.178,9.217,9.217,0,1,0-9.1-9.178Zm12.987-2.391h0a1.552,1.552,0,0,1-2.047.342,2.639,2.639,0,0,0-1.456-.518,2.488,2.488,0,0,0,0,4.955,3.034,3.034,0,0,0,1.515-.5,1.482,1.482,0,0,1,1.847.265l.038.039a1.488,1.488,0,0,1-.239,2.262,6.354,6.354,0,0,1-3.366,1.038,5.43,5.43,0,0,1-5.706-5.535,5.5,5.5,0,0,1,5.843-5.5,6.5,6.5,0,0,1,3.246.937A1.481,1.481,0,0,1,324.727,133.863Z",
    transform: "translate(-309.333 -124.599)",
    fill: "#121936"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2554",
    "data-name": "Group 2554",
    transform: "translate(63.079 206.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8564",
    "data-name": "Path 8564",
    d: "M317.521,363.1v36.3a26.019,26.019,0,0,0,26.018,26.019h4.831a31.264,31.264,0,0,0,31.264-31.264h0a22.007,22.007,0,0,1,22.007-22.007h9.05a18.68,18.68,0,0,1,5.922.962v-.962h.213V358.5a17.611,17.611,0,0,0-17.611-17.611H296.3v.025A22.211,22.211,0,0,1,317.521,363.1Z",
    transform: "translate(-220.855 -340.885)",
    fill: "#f4f2ed"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    transform: "translate(336.058 86.382)",
    fill: "none",
    stroke: "#faf8f3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8565",
    "data-name": "Path 8565",
    d: "M563.464,410.568l-.19-14.018a17.611,17.611,0,0,0-17.611-17.611H442.751v.962a18.72,18.72,0,0,1,12.794,17.754V406.5A27.559,27.559,0,0,0,483.1,434.059h99.947A24.276,24.276,0,0,1,563.464,410.568Z",
    transform: "translate(-246.994 -347.677)",
    fill: "#faf8f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8566",
    "data-name": "Path 8566",
    d: "M204.463,419.837a19.7,19.7,0,0,0,.441,4.14,22.8,22.8,0,0,1-.386-4.319Z",
    transform: "translate(-204.463 -354.945)",
    fill: "#121936"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    transform: "translate(236.111 86.382)",
    fill: "none",
    stroke: "#121936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8567",
    "data-name": "Path 8567",
    d: "M413.11,399.707v-8.844a18.718,18.718,0,0,0-18.717-18.716h-9.05a22.007,22.007,0,0,0-22.007,22.007h0a31.264,31.264,0,0,1-31.264,31.264h-4.831A26.019,26.019,0,0,1,301.225,399.4V363.1a22.211,22.211,0,0,0-21.22-22.187c-.329-.014-.66-.025-.993-.025h0a27.148,27.148,0,0,0-27.149,27.149v29.721A27.664,27.664,0,0,1,224.2,425.418h0a19.646,19.646,0,0,1-19.2-15.5c1.889,10.112,10.551,17.35,21.37,17.35h214.3A27.559,27.559,0,0,1,413.11,399.707Z",
    transform: "translate(-204.559 -340.885)",
    fill: "#121936"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2561",
    "data-name": "Group 2561",
    transform: "translate(165.595 202.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2557",
    "data-name": "Group 2557",
    transform: "translate(0 38.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2556",
    "data-name": "Group 2556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8568",
    "data-name": "Path 8568",
    d: "M224.313,285.061c-3.892-8.338-12.789-2.214-18.592.738-2.626,1.6-5.048,3.036-7.321,4.36.443-3.129.881-6.294.216-9.447a3.724,3.724,0,0,0-1.535-2.62,2.4,2.4,0,0,0-2.206.044,6.074,6.074,0,0,0-1.7,1.444c-4.688,5.176-15.211,22.924-15.211,22.924a47.766,47.766,0,0,0-3.96,13.762c-1.809,13.713,10.67,26.249,23.811,23.527a10.148,10.148,0,0,0,4.065-1.648l22.093-15.856c4.224-2.692,4.688-9.423.761-9.488,3.757-1.12,7.385-3.763,5.231-8.454-.905-2.712-3-3.112-5.24-2.762,3.4-1.114,6.466-2.891,4.958-6.9-1.042-4.55-4.726-4.7-8.17-3.88C223.741,289.758,225.431,288.055,224.313,285.061Z",
    transform: "translate(-173.832 -277.842)",
    fill: "#ffa386"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8569",
    "data-name": "Path 8569",
    d: "M192.016,298.717a.821.821,0,0,1-.414-1.531l11.942-6.957a.821.821,0,1,1,.826,1.42l-11.942,6.957A.818.818,0,0,1,192.016,298.717Z",
    transform: "translate(-176.931 -280.033)",
    fill: "#ff6a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8570",
    "data-name": "Path 8570",
    d: "M221.207,299.086a.822.822,0,0,1-.426-1.526c.835-.5,8.195-4.925,9.755-5.35a.822.822,0,0,1,.432,1.586c-1.009.274-6.263,3.317-9.338,5.171A.815.815,0,0,1,221.207,299.086Z",
    transform: "translate(-182.141 -280.401)",
    fill: "#ff6a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8571",
    "data-name": "Path 8571",
    d: "M226.611,311.911a.821.821,0,0,1-.412-1.532l7.514-4.351a.821.821,0,1,1,.822,1.421l-7.513,4.351A.81.81,0,0,1,226.611,311.911Z",
    transform: "translate(-183.106 -282.853)",
    fill: "#ff6a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8572",
    "data-name": "Path 8572",
    d: "M229.334,324.2a.822.822,0,0,1-.4-1.541l4.1-2.254a.821.821,0,1,1,.79,1.439l-4.1,2.254A.813.813,0,0,1,229.334,324.2Z",
    transform: "translate(-183.592 -285.42)",
    fill: "#ff6a48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2560",
    "data-name": "Group 2560",
    transform: "translate(141.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2558",
    "data-name": "Group 2558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8573",
    "data-name": "Path 8573",
    d: "M415.544,231.228l5.038,4.321a3.151,3.151,0,0,1,.237,4.448l-4.525,5.276a3.15,3.15,0,0,1-4.431.443l-5.038-4.321a3.151,3.151,0,0,1-.237-4.447l4.525-5.277A3.151,3.151,0,0,1,415.544,231.228Z",
    transform: "translate(-356.914 -230.512)",
    fill: "#ff6a48"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3424",
    "data-name": "Rectangle 3424",
    width: 71.77,
    height: 12.789,
    transform: "translate(5.394 58.096) rotate(-49.382)",
    fill: "#ffd066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8574",
    "data-name": "Path 8574",
    d: "M351.781,301.32l9.529,8.172c.041.035.189.162-.035.14L346.3,317.356h0l5.35-15.98C351.667,301.315,351.74,301.284,351.781,301.32Z",
    transform: "translate(-346.297 -243.148)",
    fill: "#ffaa89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8575",
    "data-name": "Path 8575",
    d: "M348.28,313.873l3.41,2.925c.015.013.068.058-.012.051l-5.361,2.764h0l1.915-5.719A.032.032,0,0,1,348.28,313.873Z",
    transform: "translate(-346.301 -245.39)",
    fill: "#233863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8576",
    "data-name": "Path 8576",
    d: "M405.446,255.4a.411.411,0,0,1-.312-.678l6.721-7.836a.411.411,0,0,1,.624.535l-6.721,7.835A.41.41,0,0,1,405.446,255.4Z",
    transform: "translate(-356.781 -233.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8577",
    "data-name": "Path 8577",
    d: "M385.351,266.139a.412.412,0,0,1-.312-.679l19.377-22.593a.411.411,0,1,1,.624.535L385.663,266A.412.412,0,0,1,385.351,266.139Z",
    transform: "translate(-353.194 -232.692)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2559",
    "data-name": "Group 2559",
    transform: "translate(6.268 19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8578",
    "data-name": "Path 8578",
    d: "M524.388,333.38l-82.9-54.829-19.215-15.058a36.187,36.187,0,0,0-18.633-7.514l-22.017-2.254a16.386,16.386,0,0,0-9.171,1.732L362,260.836a4.694,4.694,0,0,0-2.535,4.492l.083,1.226-.8.383a6.3,6.3,0,0,0-3.591,5.706l.013,4.324-.72,1.69a6.5,6.5,0,0,0,1.127,6.876L371.8,303.741a2.56,2.56,0,0,0,3.756.071,7.31,7.31,0,0,0,.426-9.654l-5.02-6.233,16.811,9.952a20.282,20.282,0,0,0,9.088,2.79l10.367.636,10.718,12.236,64.294,77.57a45.235,45.235,0,0,0,27.729,14.2c20.476,2.524,39.947-9.672,47.483-28.878l5.88-12.873Z",
    transform: "translate(-353.927 -253.64)",
    fill: "#ffaa89"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8579",
    "data-name": "Path 8579",
    d: "M360.925,269.6a.821.821,0,0,1-.25-1.6l12.491-3.986a.822.822,0,1,1,.5,1.566l-12.491,3.986A.794.794,0,0,1,360.925,269.6Z",
    transform: "translate(-348.761 -236.485)",
    fill: "#ff6a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8580",
    "data-name": "Path 8580",
    d: "M355.859,281.673a.821.821,0,0,1-.2-1.618l15.526-3.951a.822.822,0,0,1,.406,1.592l-15.526,3.95A.793.793,0,0,1,355.859,281.673Z",
    transform: "translate(-347.857 -238.645)",
    fill: "#ff6a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8581",
    "data-name": "Path 8581",
    d: "M373.807,295.257a.818.818,0,0,1-.612-.274l-3.129-3.5a.822.822,0,0,1,1.225-1.1l3.128,3.5a.822.822,0,0,1-.612,1.369Z",
    transform: "translate(-350.502 -241.151)",
    fill: "#ff6a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8582",
    "data-name": "Path 8582",
    d: "M418.632,312.2a.821.821,0,0,1-.031-1.642l12.241-.481a.821.821,0,1,1,.064,1.641l-12.241.481Z",
    transform: "translate(-359.061 -244.712)",
    fill: "#ff6a48"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacypolicy);
export default __webpack_public_path__ + "static/media/privacy&policy.94ddc2d976b6c8cab3f1e4ef1f786021.svg";
export { ForwardRef as ReactComponent };